import CloseIcon from "@mui/icons-material/Close";

export function ConfirmationForm({ isOpen,
  onClose,
  handleConfirm }
) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Are you sure you want to add this employee?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleConfirm}
                style={{ marginRight: "5px" }}>
                ADD
              </button>
              <button id="add-family"
                className="cancel row"
                style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export function ConfirmationBulkForm({ isOpen,
  onClose,
  handleConfirm }
) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add Employee/s</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Are you sure you want to add this employee?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleConfirm}
                style={{ marginRight: "5px" }}>
                ADD
              </button>
              <button id="add-family"
                className="cancel row"
                style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}